import type { Options } from '@emotion/cache';
import { default as emotionCreateCache } from '@emotion/cache';

export const createCache = (options: Options) => {
  return emotionCreateCache(options);
};
